import { useSelector } from 'react-redux';
import { isFormElemEditable } from '../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../../store';

export function useSetFormControlConfig(): any {

  const { payerList: { formControlConfig }, admissionDetails: { claimDetails } } =
    useSelector((state: RootState): RootState =>
      state);

  const getValueBasedOnConfig = (key: string, assignedValue: any): any => {
    const { editBlank, editFor }: any = formControlConfig[key] || {};
    const isFormEdit = isFormElemEditable(editFor, claimDetails);
    if (editBlank && isFormEdit) {
      return undefined;
    }
    return assignedValue;
  };

  return (isPageNameDetail: boolean, formValues: any): any => {
    Object.keys(formValues)
      .forEach((key: string): void =>
        formValues[key] = isPageNameDetail ? formValues[key] : getValueBasedOnConfig(key, formValues[key]));
    return formValues;
  };
}
